export enum AuditAreas {
    Facility = "Facility",
    Member = "Member",
    Package = "Package",
    Region = "Region",
    User = "User",
    Employer = "Employer"
}
